import React, { useState, useEffect } from 'react'

const InputRow = ({ rowData, formatting, editMode, last, updateRowData, customStyleId, index, replant, fieldLost, isDisable }) => {
  const [myRowData, setData] = useState(rowData)
  useEffect(() => {
    setData({ ...rowData })
  }, [rowData])
  
  const dataChange = (e, col, id, type, index) => {
    e.persist()
    updateRowData(col, e.target.value, id, type, index)
    setData(prev => {
      return { ...prev, [col]: e.target.value }
    })
  }

  const genCols = mRD => {
    const colArray = []
    let rowDataObj = myRowData
    if (rowData instanceof Map) {
      for (var [key, value] of rowData) {
        if (key !== 'id') {
          colArray.push(<div key={key} className={`${key} cell`}>{value || '--' }</div>)
        }
      }
    } else {
      if (editMode) {
        for (let col in rowDataObj) {
          if (formatting[col]) {
            colArray.push(
              <div id={(customStyleId && customStyleId[col]) || ''} className={`cell ${col}`} key={col}>
                {formatting[col](mRD[col], e => dataChange(e, col, rowDataObj.id, rowDataObj.type), index )}
              </div>
            )}
        }
      } else {
        for (let col in rowDataObj) {
          if (formatting[col]) {

            if(col === 'name' && fieldLost) {
              colArray.push(
                <div id={(customStyleId && customStyleId[col]) || ''} key={col} className={`${col} cell  df fxww aic`}>
                  <span style={{ maxWidth:'160px', overflow:'hidden', textOverflow: 'ellipsis' }}>{rowDataObj[col] || '--' }</span><span className="fz12" style={{ color: 'red' }}> (Lost)</span> </div> 
              )
            } 
            else if (col === 'name' && replant) {
              colArray.push(
                <div id={(customStyleId && customStyleId[col]) || ''} key={col} className={`${col} cell  df fxww aic`}>
                  <span style={{ maxWidth:'160px', overflow:'hidden', textOverflow: 'ellipsis' }}>{rowDataObj[col] || '--' }</span><span className="fz12" style={{ color: 'red' }}> (Replant)</span> </div> 
              )
            }
            else {
              colArray.push(
                <div id={(customStyleId && customStyleId[col]) || ''} key={col} className={`${col} cell`}>
                  {rowDataObj[col] || '--' }</div>
              )
            }
          }
        }
      }
    }
    return colArray
  }

  return (
    <div role='row' className={`pl16 df h48 ov dp aic${!last ? ' bb1-s-lightgray bnn' : ''}`} 
      style={{ color: fieldLost || isDisable ? '#A5A5AE' : '' }}>
      {genCols(myRowData)}
    </div>
  )
}

export default InputRow